import React, { useContext } from 'react';
import Card from '../card';
import { MaterialsContext } from '../../../context/MaterialsContext';
import style from './style.module.scss';
import Modal from '../../modal';
import Button from '../../button';
import { materials_tr } from '../../../lang/materials';

export default function List() {
  const { categories, filteredData, modalContent, setModalContent, setCurrentPage, loadMore } = useContext(MaterialsContext);

  return (
    <>
      {categories &&
        categories.length > 0 &&
        categories.map(category => {
          return (
            filteredData &&
            filteredData.length > 0 && (
              <div
                key={category.title + '_list'}
                className={style.container}
              >
                {filteredData.some(i => i.category == category.title) && <h2 className={style.categoryTitle}>{category.title}</h2>}
                <div className={style.list}>
                  {filteredData
                    .filter(i => i.category == category.title)
                    .map(data => {
                      return (
                        <Card
                          data={data}
                          key={data.id + '_card'}
                        />
                      );
                    })}
                </div>
              </div>
            )
          );
        })}

      {loadMore && (
        <div className={style.lastPageButton}>
          <Button
            size="full"
            onClick={e => setCurrentPage(e => e + 1)}
          >
            <span className="fa fa-plus"></span>
            {materials_tr().button_show_more}
          </Button>
        </div>
      )}

      {!filteredData ||
        (filteredData.length === 0 && (
          <>
            <p className={style.noMatch}>{materials_tr().no_results}</p>
            <img
              src="/images/icons/nomatch.svg"
              alt="Nenhum resultado encontrado"
              className={style.noMatchImg}
            />
          </>
        ))}

      <Modal
        modalContent={modalContent}
        setModalContent={setModalContent}
      />
    </>
  );
}
